import { SuretyAccountId, SuretyQuoteId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { bondRequestBondFormQueryKey } from "../bond-request.keys";
import { QuoteBondForm } from "./types";

export const useFetchQuoteBondForm = (accountId: SuretyAccountId, quoteId: SuretyQuoteId) => {
	const { get } = useRequest();

	const { data, error, isLoading } = useQuery({
		queryKey: bondRequestBondFormQueryKey(quoteId),
		queryFn: async () =>
			await get<QuoteBondForm>(`/v2/surety/accounts/${accountId}/quotes/${quoteId}/bond-form`),
		retry: false,
	});

	return {
		quoteBondForm: data,
		quoteBondFormError: error,
		quoteBondFormIsLoading: isLoading,
	};
};
